import { render } from "./stage-settings.vue?vue&type=template&id=424d9bd9"
import script from "./stage-settings.vue?vue&type=script&lang=js"
export * from "./stage-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__